import { useAgent } from "../../common/hooks/useAgents";
import type { Agent } from "../../common/types/Agent";
import { isTypeOf } from "../../common/utils/zod.util";
import { AgentId } from "../../common/validate";

type Props = {
    agent: string | undefined;
    children: (agent: Agent) => React.JSX.Element;
};

function FetchAgent(props: Props) {
    const { agent: agentId, children } = props;
    const agent = useAgent(agentId && isTypeOf(agentId, AgentId) ? agentId : undefined);

    if (!agent) {
        return null;
    }
    return children(agent);
}

export default FetchAgent;
